import React from 'react';
import './SkeletonPage.scss'; // Убедитесь, что стили находятся в этом файле
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';


const SkeletonPage = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 1) !important', // Полупрозрачный фон для затемнения
        zIndex: 9999, // Высокий z-index, чтобы перекрывать остальные элементы
      }}>
      <CircularProgress size={100} />
    </Box>
  );
};

export default SkeletonPage;
